import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ServiceService } from 'src/app/service.service';
import { GlobalConstants } from '../../global-config'

declare var $: any;



@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    categorylist = [];
    // mybutton;
    constructor( 
        private service: ServiceService,
        private translateService: TranslateService
        ) {    
            translateService.addLangs(['en', 'de']);
            translateService.setDefaultLang('en');
        }


  
    ngOnInit() {
        // this.categoryList();
        $(window).scroll(function () {
            if ($(window).scrollTop() >= 30) {
                $("header").addClass("fixed-header");
            } else {
                $("header").removeClass("fixed-header");
            }
        });

        // hash tag loading
        

        //Get the button
        // this.mybutton = document.getElementById("myBtn");
        // When the user scrolls down 20px from the top of the document, show the button
        window.onscroll = function () { scrollFunction() };
        function scrollFunction() {
            // alert("window is scrolling...");
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                document.getElementById("myBtn").style.display = "block";
            } else {
                document.getElementById("myBtn").style.display = "none";
            }
        };

        // When the user clicks on the button, scroll to the top of the document

    }


    topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    
//   categoryList() {
//     this.ServiceService.getdata().subscribe((data: any[]) => {
//        // console.log(data);
//        this.categorylist = data;
//     });
//     (error) => {
//       console.log("no data found");
//     };
//   }
switchLanguage(language: string) {
    console.log(language);
//    alert(language);
    this.translateService.use(language);
    // alert('aaaaaaaaaaaaaaaaaaaa');
  }

  tryNowPlan(){
    let planInfo = {
        plan_id: 5,
        user_count: 1,
        plan_amount: 0,
        duration: 14,
        discount: 0,
        currency_type: 'inr'
      }
      console.log(planInfo);
  
      let replacedkeyByDollerAlpha = this.service.getEncryptKey(planInfo);
     
      window.location.href = GlobalConstants.domainURL +'/signup' + '?key=' + replacedkeyByDollerAlpha;
      // window.location.href = 'http://localhost:4201?key='+ encrypted;
  }
}
